// @flow
import styled from 'styled-components';
import {
  textNormal,
  textBlack,
  textBold,
  textBoldLoose,
  textSemiBold,
} from './css';
import { Text8 } from './Text';

export const Text8Normal = styled(Text8)`
  ${textNormal};
`;

export const Text8Black = styled(Text8)`
  ${textBlack};
`;

export const Text8SemiBold = styled(Text8)`
  ${textSemiBold};
`;

export const Text8Bold = styled(Text8)`
  ${textBold};
`;

export const Text8BoldLoose = styled(Text8)`
  ${textBoldLoose};
`;
